export const sort = [
  { label: "ID", name: "id", style: { width: 80 } },
  { label: "Podgląd", name: "image", sortable: false, style: { width: 120 } },
  { label: "Nazwa", name: "name" },
];

export const filters = [
  {
    type: "input",
    name: "id",
    sort_id: "id",
    search_type: "matches",
  },
  {
    type: "input",
    name: "name",
    sort_id: "name",
    search_type: "matches",
  },
];
